import React, { useState, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import Slider from "@mui/material/Slider";
import { dbFormatDate, formatDate, standardFormatToday } from "../../../api_calls/utils";
import DatePicker from "react-datepicker";
import { DateRange } from "@mui/icons-material";
import moment from "moment/moment";
import platformConfig from "../../../platformConfig";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../Store/actions";

const epochDate = new Date("1970-01-01");

function fromNumberToDate(dateSerialNum) {
  return new Date(epochDate.getTime() + dateSerialNum * 24 * 60 * 60 * 1000);
}

const DateRangeFilter = ({ onValueChange, vizId, fieldName, minSelectableDate, maxSelectableDate, reduxKeywordToSaveValue }) => {
  const dispatchAction = useDispatch();
  const currentStateData = useSelector((state) => state.userSelections);

  const startDate =
    typeof minSelectableDate !== "undefined" && minSelectableDate !== ""
      ? new Date(minSelectableDate)
      : new Date("2022-10-01");

  // end date will always be (today - 1day)
  const today = standardFormatToday();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  // set end date
  const endDate =
    typeof maxSelectableDate !== "undefined" && maxSelectableDate !== "" ? new Date(maxSelectableDate) : yesterday;

  const dateToValue = (date) => {
    // console.log(date, Math.floor((date - epochDate) / (24 * 60 * 60 * 1000)))
    return Math.floor((date - epochDate) / (24 * 60 * 60 * 1000));
  };

  const [selectedStartDate, setSelectedStartDate] = React.useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = React.useState(endDate);

  const [range, setRange] = useState([dateToValue(startDate), dateToValue(endDate)]);

  const handleChange = (event, newRange) => {
    setRange(newRange);
    setSelectedStartDate(new Date(fromNumberToDate(newRange[0])));
    setSelectedEndDate(new Date(fromNumberToDate(newRange[1])));
  };

  const handleCommittedChange = () => {
    // Use the functional form of state update to ensure the latest state values
    setRange((prevRange) => {
      const startDate = fromNumberToDate(prevRange[0]);
      const endDate = fromNumberToDate(prevRange[1]);

      if (typeof vizId !== "undefined") {
        onValueChange(fieldName, [startDate, endDate], vizId);
      } else {
        // Use the functional form of state update to ensure the latest state values
        dispatchAction(updateStateData({
          [reduxKeywordToSaveValue]: {
            ...currentStateData[reduxKeywordToSaveValue],
            from: startDate,
            to: endDate
          }
        }));
      }
      return prevRange; // Return the same range to avoid unnecessary re-renders
    });
  };

  const handleStartDateChange = (event) => {
    const startDate = dateToValue(event);
    setSelectedStartDate(event);
    if (startDate < dateToValue(endDate)) {
      setRange([startDate, range[1]]);
    }

    setTimeout(() => {
      handleCommittedChange();
    }, 500);
  };

  const handleEndDateChange = (event) => {
    const endDate = dateToValue(event);
    setSelectedEndDate(event);
    if (endDate > dateToValue(startDate)) {
      setRange([range[0], endDate]);
    }
    setTimeout(() => {
      handleCommittedChange();
    }, 500);
  };

  useEffect(() => {
    setRange([dateToValue(startDate), dateToValue(endDate)]);
    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);
    setTimeout(() => {
      handleCommittedChange();
    }, 500);
  }, [minSelectableDate, maxSelectableDate]);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 0, fontSize: "11px", color: "#AF3241" }}>
        <span>Period</span>
      </Box>

      <Slider
        getAriaLabel={() => "Date range"}
        value={range}
        min={dateToValue(startDate)}
        max={dateToValue(endDate)}
        step={1}
        onChange={handleChange}
        onChangeCommitted={handleCommittedChange}
        valueLabelDisplay="auto"
        valueLabelFormat={(values) => {
          const date = fromNumberToDate(values);
          return formatDate(date);
        }}
        sx={{ color: "#AF3241", position: "sticky" }}
        size="small"
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
        <span>
          <Stack direction={"row"} spacing={1}>
            {/* <DateRange sx={{ fontSize: "15px" }} /> */}
            <Typography variant="body2">{formatDate(fromNumberToDate(range[0]))}</Typography>
          </Stack>
          {/* <DatePicker
            selected={selectedStartDate}
            onChange={handleStartDateChange}
            customInput={
              <Stack direction={"row"} spacing={1}>
                <DateRange sx={{ fontSize: "15px" }} />
                <Typography variant="body2">{formatDate(fromNumberToDate(range[0]))}</Typography>
              </Stack>
            }
            minDate={startDate}
          /> */}
        </span>
        <span>
          {/* .toISOString().split("T")[0] */}
          <Stack direction={"row"} spacing={1}>
            {/* <DateRange sx={{ fontSize: "15px" }} /> */}
            <Typography variant="body2">{formatDate(fromNumberToDate(range[1]))}</Typography>
          </Stack>
          {/* <DatePicker
            selected={selectedEndDate}
            onChange={handleEndDateChange}
            customInput={
              <Stack direction={"row"} spacing={1}>
                <DateRange sx={{ fontSize: "15px" }} />
                <Typography variant="body2">{formatDate(fromNumberToDate(range[1]))}</Typography>
              </Stack>
            }
            maxDate={endDate}
          /> */}
        </span>
      </Box>
    </>
  );
};

export default DateRangeFilter;
